import { Link } from "react-router-dom";
import useFetch from "../hook/useFetch";
import SectionHeader from "./SectionHeader";
import CameraImg from "../img/camera.png";

export default function CategoryShowcase() {
  const { data } = useFetch("/categories");
  const categories = Array.isArray(data) ? data : [];

  return (
    <section id="shop" className="mb-20 scroll-mt-24">
      <div className="container mx-auto">
        <SectionHeader title="All Products" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[15px] md:gap-[30px]">
          {categories.map((category) => (
            <Link
              key={category._id}
              to={`/products/${category.slug}`}
              className="group relative flex flex-col items-center justify-center h-[230px] card overflow-hidden hover:border-brand/50 transition-colors">
              {/* watermark */}
              <span
                aria-hidden="true"
                className="pointer-events-none select-none absolute inset-0 flex items-center justify-center font-display font-bold uppercase text-ink/[0.04] text-5xl tracking-tight">
                {category.title}
              </span>
              <img
                src={CameraImg}
                alt=""
                className="relative w-[130px] h-[130px] object-contain mb-4 transition-transform duration-300 group-hover:scale-95"
              />
              <span className="relative block w-8 h-[3px] bg-brand mb-3 rounded-full" />
              <span className="relative uppercase tracking-[0.15em] text-sm text-ink">
                {category.title} Cameras
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
